module.exports = [
  require('./list/platinum_scarf'),
]
